export const login = {
  welcomeBack: '欢迎回来',
  signInToContinue: '登录以继续',
  continueWithGoogle: '使用 Google 继续',
  continueWithApple: '使用 Apple 继续',
  orContinueWithEmail: '或使用邮箱继续',
  emailAddress: '邮箱地址',
  emailPlaceholder: 'your@email.com',
  password: '密码',
  passwordPlaceholder: '请输入密码',
  forgotPassword: '忘记密码？',
  enterEmailToReset: '请先在上方填写邮箱，然后点"忘记密码？"。',
  resetEmailSent: '已向 {{email}} 发送密码重置邮件，请查收。',
  signIn: '登录',
  signingIn: '登录中...',
  dontHaveAccount: '还没有账号？',
  signUp: '注册',
  copyright: '© 2026 Acework. 保留所有权利。',
  createYourAccount: '创建你的账号',
  alreadyHaveAccount: '已经有账号了？',
  creatingAccount: '正在创建账号...',
  displayName: '显示名称',
  displayNamePlaceholder: '别人看到的名字',
  handle: '用户标识',
  handlePlaceholder: 'alex.johnson',
  handleHint: '3–20 个字符 · 仅限小写字母、数字、点和下划线 · 必须以字母开头。',
  country: '国家/地区',
  countryPlaceholder: '选择你的国家/地区',
  countryRequired: '国家/地区是必需的',
  city: '城市',
  cityPlaceholder: '选择你的城市',
  cityRequired: '城市是必需的',
  cityOther: '其他...',
  cityOtherPlaceholder: '输入你的城市',
  countryAndCityRequired: '国家/地区和城市是必需的',
};
